import React from 'react';
import { Box, Typography } from '@mui/material';

type Props = {
  items: string[];
};

const HierarchyWidget: React.FC<Props> = ({items}) => {
    return (
        <Box sx={{ p: { xs: 0.75, sm: 1.25 }, minWidth: { xs: 160, sm: 220 }, bgcolor: 'transparent' }}>
            <Typography sx={{ fontFamily: 'Montserrat', fontWeight: 600, fontSize: { xs: 12, sm: 13 }, mb: 0.75, color: '#E6F6FF' }}>
            Hierarchy
            </Typography>

            {/* vertical guide (subtle) */}
            <Box sx={{ position: 'relative', pl: 1 }}>
            {items.map((item, idx) => {
                const isLastBefore = idx === items.length - 2;
                const remainingRows = Math.max(0, items.length - idx - 1);
                const ROW_PX = 34; 
                const verticalLineHeight = remainingRows > 0 ? remainingRows * ROW_PX : 0;
                return (
                <Box
                key={`${item}-${idx}`}
                sx={{
                    display: 'flex',
                    fontFamily: 'Montserrat',
                    alignItems: 'center',
                    gap: 1,
                    py: { xs: 0.4, sm: 0.75 },
                    pl: `${(idx < items.length - 1) ? idx * 24 : idx * 20}px`,
                }}
                >
                {/* connector column */}
                <Box sx={{ width: 20, display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    {idx >= 0 && idx < items.length - 1 && (
                    <Box sx={{ position: 'relative', width: 18, height: 22 }}>
                        {/*  vertical connector (light blue) */}
                        <Box
                        sx={{
                            position: 'absolute',
                            left: 12.5,
                            top: '50%',
                            bottom: 0,
                            width: 1.5,
                            height: `${verticalLineHeight}px`,
                            bgcolor: '#003771',
                            borderRadius: 1,
                        }}
                        />
                        {/* horizontal connector base (light blue) */}
                        <Box
                        sx={{
                            position: 'absolute',
                            left: 12.5,
                            top: 'calc(100% + 23px)', 
                            // transform: 'translateY(-50%)',
                            width: isLastBefore ? 20 : 12,
                            height: 1.5,
                            bgcolor: '#003771',
                            borderRadius: 1,
                        }}
                        />
                        {/* horizontal connector */}
                        <Box
                        sx={{
                            position: 'absolute',
                            left: 8,
                            top: '50%',
                            // transform: 'translateY(-50%)',
                            width: 12,
                            height: 2,
                            bgcolor: '#fff',
                            borderRadius: 1,
                        }}
                        />
                    </Box>
                    )}
                </Box>
                <Typography
                    sx={{
                    color: '#fff',
                    whiteSpace: 'nowrap',
                    fontFamily: 'Montserrat',
                    fontSize: { xs: 12, sm: 12 },
                    lineHeight: '20px',
                    ml: idx === 0 ? '4px' : 0,
                    }}
                >
                    {item}
                </Typography>
                </Box>
                );
            })}
            </Box>
        </Box>
    );
};

export default HierarchyWidget;